

import React, { useEffect } from 'react'
import Event from './eventImg/event-20-dec-2.webp'


const Event23 = () => {
    useEffect(() => {
        document.title = "ISHRAE Knowledge talk on Electrical Safety";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>20 December 2025</h1>
        <h3 className='text-center'>ISHRAE Knowledge talk on Electrical Safety</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={Event} alt='ISHRAE Knowledge talk on Electrical Safety'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/R58E3zXJXTU=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event23




